import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft} from 'lucide-react';
import Footer from "./Footer"

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="container">

      <button onClick={() => navigate('/')} className="back-btn">
        <ArrowLeft size={20} />
        Back to Home
      </button>

      <div className="card">
        
        
        <h1 className="title">Privacy Policy</h1>
        <p>
          This privacy policy explains how we collect, use, and protect your personal information in accordance with the Data Protection Act 2018 and the UK General Data Protection Regulation (UK GDPR).
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect and process the following data about you:</p>
        <ul>
          <li>Personal details (such as name, email address, contact details)</li>
          <li>Usage data (such as pages visited, browser type, IP address)</li>
          <li>Technical data (such as device type, operating system)</li>
          <li>Any information you voluntarily submit via forms</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your personal data to:</p>
        <ul>
          <li>Provide and maintain our service</li>
          <li>Improve user experience</li>
          <li>Respond to enquiries and support requests</li>
          <li>Send service-related updates (if opted-in)</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2>3. Legal Bases for Processing</h2>
        <p>We rely on the following lawful bases for processing personal data:</p>
        <ul>
          <li>Consent – where you have given clear consent</li>
          <li>Contract – where processing is necessary for a contract</li>
          <li>Legal obligation – for compliance with the law</li>
          <li>Legitimate interests – where we have a legitimate business reason</li>
        </ul>

        <h2>4. Data Retention</h2>
        <p>We will retain your personal data only for as long as is necessary for the purposes set out in this policy, and to comply with legal obligations.</p>

        <h2>5. Sharing Your Data</h2>
        <p>Your data may be shared with:</p>
        <ul>
          <li>Service providers who assist with our operations (e.g. hosting, analytics)</li>
          <li>Regulatory authorities when required by law</li>
        </ul>
        <p>We never sell or rent your personal data.</p>

        <h2>6. Your Rights</h2>
        <p>Under UK GDPR, you have the right to:</p>
        <ul>
          <li>Access the personal data we hold about you</li>
          <li>Request correction or deletion of your data</li>
          <li>Withdraw your consent at any time</li>
          <li>Object to or restrict certain types of processing</li>
          <li>Data portability (receive your data in a machine-readable format)</li>
        </ul>

        <h2>7. Cookies</h2>
        <p>We use cookies to enhance your browsing experience. You can control your cookie preferences through your browser settings.</p>

        <h2>8. International Transfers</h2>
        <p>If we transfer your data outside the UK, we ensure appropriate safeguards are in place.</p>

        <h2>9. Data Security</h2>
        <p>We implement appropriate technical and organisational measures to protect your data from unauthorised access, use, or disclosure.</p>

        <h2>10. Changes to This Policy</h2>
        <p>We may update this policy from time to time. We will notify you of any significant changes by posting the new policy on this page.</p>

        <h2>11. Contact</h2>
        <p>If you have any questions or requests about this policy, you can contact us at:</p>
        <p><strong>Email:</strong> support@elo-board.com</p>

        <br></br>
      </div>



      <Footer />
      
    </div>
  );
};

export default PrivacyPolicy;
